module.exports = __webpack_public_path__ + "static/img/icon_szh_cgal_gk_ycjk@2x.802af8ba.png";